import _default from "../../system/createStyled.es.js";
import defaultTheme from "./defaultTheme.es.js";
import THEME_ID from "./identifier.es.js";
import rootShouldForwardProp from "./rootShouldForwardProp.es.js";
const styled = _default({
  themeId: THEME_ID,
  defaultTheme,
  rootShouldForwardProp
});
export {
  styled as default,
  rootShouldForwardProp
};
//# sourceMappingURL=styled.es.js.map
